import React from "react";
import CalendlyTabs from "./CalendlyTab";
const BookCalendlyMeetingPage = () => {
  return (
    <div className="container">
      <CalendlyTabs />
    </div>
  );
};

export default BookCalendlyMeetingPage;